export var MarkType;
(function (MarkType) {
    MarkType["Bar"] = "Bar";
    MarkType["Line"] = "Line";
    MarkType["Area"] = "Area";
    MarkType["Square"] = "Square";
    MarkType["Circle"] = "Circle";
    MarkType["Shape"] = "Shape";
    MarkType["Text"] = "Text";
    MarkType["Map"] = "Map";
    MarkType["Pie"] = "Pie";
    MarkType["Donut"] = "Donut";
    MarkType["TotalArea"] = "TotalArea";
})(MarkType || (MarkType = {}));
export const AllowedMarkChannels = {
    [MarkType.Bar]: ['color', 'size', 'text', 'detail', 'baseline'],
    [MarkType.Line]: ['color', 'size', 'text', 'detail'],
    [MarkType.Area]: ['color', 'text', 'detail', 'baseline'],
    [MarkType.TotalArea]: ['color', 'text', 'detail'],
    [MarkType.Square]: ['color', 'size', 'text', 'detail'],
    [MarkType.Circle]: ['color', 'size', 'text', 'detail'],
    [MarkType.Shape]: ['color', 'size', 'text', 'detail'],
    [MarkType.Text]: ['color', 'size', 'text', 'detail'],
    [MarkType.Map]: ['color', 'size', 'text', 'detail'],
    [MarkType.Pie]: ['color', 'size', 'text', 'detail', 'angle'],
    [MarkType.Donut]: ['color', 'size', 'text', 'detail', 'angle'],
};
export const AllowedAutoMarkChannels = AllowedMarkChannels[MarkType.Bar];
